import styled from 'styled-components';

import { Label } from '@savgroup-front-common/core/atoms/Form/common';
import { Link } from '@savgroup-front-common/core/atoms/link';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

export const $ResumeCardContainer = styled.div`
  background: ${({ theme }) => theme.systemColors.defaultBackground};
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  border: 1px solid ${({ theme }) => theme.colors.default};

  height: fit-content;
`;

export const $ResumeDescriptionProduct = styled.div`
  display: flex;
  padding: ${spacing('lg')} ${spacing('xl')};
`;
export const $ResumePictureProduct = styled.div``;
export const $CardContentThumbnailWrapper = styled.div``;
export const $CardContentThumbnail = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.disabled};
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  margin-right: ${spacing('lg')};
  padding: ${spacing('xxs')};
  max-width: ${spacing(10)};
  max-height: ${spacing(10)};
  overflow: hidden;
  img {
    object-fit: contain;
    max-height: ${rem(60)};
    max-width: ${rem(60)};
  }
`;

export const $ResumeProductTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing('sm')};
`;

export const $ResumeProductTitle = styled.div`
  font-weight: ${fontWeight('medium')};
  ${fontStyle('base')};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
`;

export const $ResumeInfoProduct = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('sm')};
  max-width: 230px;
`;

export const $ResumeInfoProductTitle = styled.div`
  font-weight: ${fontWeight('medium')};
  ${fontStyle('base')};
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
  max-width: 230px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs')};
`;

export const $ResumeSeparator = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.default};
  width: 100%;
  height: 0;
`;

export const $ResumeStateProduct = styled.div`
  padding: 1rem ${spacing('xl')};
`;

export const $ResumeStateLabel = styled(Label)`
  line-height: 20px;
  margin-right: ${spacing('sm')};
`;
export const $ResumeStateValue = styled.span`
  font-weight: ${fontWeight('normal')};
  ${fontStyle('xs')};
  line-height: 20px;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
`;

export const $ResumeStateProductModify = styled(Link)`
  font-weight: ${fontWeight('normal')};
  ${fontStyle('sm')};
  display: flex;
  align-items: center;
  text-align: right;
  text-decoration-line: underline;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
`;
export const $ResumeStateProductKeyValue = styled.div`
  margin: ${spacing('sm')} 0;
`;
export const $ResumeStateProductDocuments = styled.div`
  ${$ResumeStateValue} {
    display: block;
    margin-top: ${spacing('sm')};
    margin-left: 0;
  }
`;

export const $ResumeStateValueDocument = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing('xs')};
  font-weight: ${fontWeight('normal')};
  ${fontStyle('xs')};
  text-decoration-line: underline;
  margin-bottom: ${spacing('sm')};
  & svg {
    margin-bottom: calc(-1 * ${spacing('xxs')});
  }
`;

export const $ResumePriceProduct = styled.div`
  padding: 1rem ${spacing('xl')};
`;
export const $ResumePriceProductInfoAmountWrapper = styled.div`
  display: flex;
  font-weight: ${fontWeight('normal')};
  ${fontStyle('xs')};
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
  justify-content: space-between;
  margin-bottom: ${spacing('sm')};
  align-items: center;
`;
export const $ResumePriceProductInfoAmountLabel = styled.div`
  line-height: 20px;
`;
export const $ResumePriceProductInfoAmountValue = styled.div`
  line-height: 14px;
`;
export const $ResumePriceProductInfoAmountTotalLabel = styled.div`
  font-weight: 700;
  ${fontStyle('sm')};
`;
export const $ResumePriceProductInfoAmountTotalValue = styled.div`
  font-weight: 700;
  ${fontStyle('sm')};
`;
export const $ResumePriceProductInfoAmountTotalDescriptoinTax = styled.span`
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  font-weight: ${fontWeight('normal')};
  margin-left: ${spacing('sm')};
  ${fontStyle('xs')};
`;
